import { getCoreLevel } from '../../publicSession/selectors';
import { getMaxPriceForCoreLevel } from '../../utils/profits';
export var getMaxPrice = function (state) {
    var coreLevel = getCoreLevel(state);
    return getMaxPriceForCoreLevel(coreLevel);
};
//# sourceMappingURL=selectors.js.map